class TempStorage {
    static data = {};

    static set(key, value) {
        this.data[key] = value;
    }

    static get(key) {
        return this.data[key];
    }

    static clear() {
        this.data = {};
    }

    static remove(key) {
        delete this.data[key];
    }

    static exists(key) {
        return this.data[key] !== undefined;
    }
}

export default TempStorage;